module.exports = __webpack_public_path__ + "img/icon-bag-note-en.a4a68089.svg";